<template>
  <div class="projects-list" v-if="current.detalle.length > 0">
    <hr />
    <h6 class="text-dark text-center">
      Listado de Tarimas de Traslado
      <i class="fas fa-angle-double-down text-success"></i>
    </h6>
    <hr />
    <div
      class="project-box"
      v-for="current in current.detalle"
      v-bind:key="current.id"
      @click="rowClick(current)"
    >
      <div style="cursor: pointer; background-color: #e3ffd0">
        <div
          v-if="current.salida_e_objeto.tipo_traslado == 'T'"
          v-bind:style="{
            'background-color: #e3ffd0;': current.salida_e_objeto.tipo_traslado == 'T',
          }"
          class="project-head"
        >
          <div class="project-title">
            <h5># {{ current.numero }}</h5>
            {{ current.usuario.name }}
            <p>
              <small>{{ current.barra }}</small>
            </p>
          </div>
        </div>
        <div v-if="current.salida_e_objeto.tipo_traslado == 'T'" class="project-info">
          <div class="row align-items-center">
            <div class="col-12">
              <div class="row">
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div v-if="current.usuario" class="label">Asignado a ruta</div>
                    <div v-if="current.usuario" class="value">
                      <h6 style="color: #3ab41d">
                        <timeago :datetime="current.fecha_asignado_ruta"></timeago>
                      </h6>
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="el-tablo highlight text-center">
                    <div class="label">Estatus</div>
                    <div class="value">
                      <h6 style="color: #3ab41d">{{ current.estado_str }}</h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="project-foot">
            <button
              class="btn btn-outline-danger btn-sm btn-block"
              type="button"
              v-if="current.fecha_fin_carga == null"
              @click="eliminarDetalle(current)"
            >
              <i class="fas fa-trash"></i>
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </div>

    <hr />
    <h6 class="text-dark text-center">
      Listado de Tarimas de Devolución
      <i class="fas fa-angle-double-down text-success"></i>
    </h6>
    <hr />
    <br />
    <div
      class="project-box"
      style="cursor: pointer; background-color: #ffd4ef"
      v-for="(current, key) in current.detalle"
      :key="key"
      @click="rowClick(current)"
    >
      <div v-if="current.salida_e_objeto.tipo_traslado == 'D'" class="project-head">
        <div class="project-title">
          <h5># {{ current.numero }}</h5>
          {{ current.usuario.name }}
          <p>
            <small>{{ current.barra }}</small>
          </p>
        </div>
      </div>
      <div v-if="current.salida_e_objeto.tipo_traslado == 'D'" class="project-info">
        <div class="row align-items-center">
          <div class="col-12">
            <div class="row">
              <div class="col-6">
                <div class="el-tablo highlight text-center">
                  <div v-if="current.usuario" class="label">Asignado a ruta</div>
                  <div v-if="current.usuario" class="value">
                    <h6 style="color: #3ab41d">
                      <timeago :datetime="current.fecha_asignado_ruta"></timeago>
                    </h6>
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="el-tablo highlight text-center">
                  <div class="label">Estatus</div>
                  <div class="value">
                    <h6 style="color: #3ab41d">{{ current.estado_str }}</h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="project-foot">
          <button
            class="btn btn-outline-danger btn-sm btn-block"
            type="button"
            v-if="current.fecha_fin_carga == null"
            @click="eliminarDetalle(current)"
          >
            <i class="fas fa-trash"></i>
            Eliminar
          </button>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="opciones"
      role="dialog"
      tabindex="-1"
      style="padding-right: 15px"
    >
      <div class="modal-dialog modal-centered fade animated" role="document">
        <div class="modal-content text-center">
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span class="close-label">Cerrar</span
            ><span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding-media">
            <img alt="" src="img/bigicon2.png" width="200px" />
          </div>
          <div class="onboarding-content with-gradient">
            <h4 class="onboarding-title">Opciones</h4>
            <h5># {{ currentDetalle.numero }}</h5>
            <h5>{{ currentDetalle.piloto }}</h5>
            <h5>{{ currentDetalle.barra }}</h5>
            <br />
            <div class="onboarding-text">
              <div>
                <button
                  :disabled="current.fecha_fin_carga && currentDetalle.estado != 'D'"
                  @click="deleteTarima(currentDetalle)"
                  class="btn btn-danger"
                >
                  Eliminar Tarima de Contenedor
                </button>
              </div>
              <div>
                <br />
                <button @click="Imprimir(currentDetalle)" class="btn btn-success">
                  Reimprimir reporte de tarima
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import Notifications from "@/notifications/notifications";
import ContenedorService from "@/services/wms/ContenedorService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
  },
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
  },
  data() {
    return {
      currentDetalle: {},
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
      data: [],
      date: "",
    };
  },
  computed: {
    ...mapGetters({}),
  },
  mounted() {},
  methods: {
    Imprimir(current) {
      let self = this;
      self.id = current.id.replace(/-/g, "");
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      current;
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=wms/tarima/tarima.jrxml&id=${self.id}`
      );
    },
    deleteTarima(currentDetalle) {
      let self = this;
      Notifications.alert.confirm(
        "Eliminar la tarima del contenedor",
        "¿Esta Seguro?",
        "",
        function () {
          DynamicService.postAction(
            "wms",
            "contenedor",
            self.current.id,
            "remover_tarima_a_contenedor",
            {
              tarima_barra: currentDetalle.barra,
            }
          )
            .then((response) => {
              Notifications.toast.success(
                "Eliminar la Tarima del Contenedor",
                "Realizado correctamente"
              );
              $("#opciones").modal("hide");
              self.$emit("refresh", {});
            })
            .catch((error) => {
              Notifications.alert.error(
                "Eliminar Tarima de Contenedor",
                error.response.data.detail
              );
              $("#opciones").modal("hide");
            });
        }
      );
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("recepciones/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
    irAEsconderModal(name, params) {
      if ($(".modal").hasClass("show")) {
        $(".modal").find(".close").click();
      }
      this.$router.push({
        name: name,
        params: params,
      });
    },
    rowClick(detalle) {
      let self = this;
      $("#opciones").modal("show");
      self.currentDetalle = detalle;
    },
    eliminarDetalle(current) {
      let self = this;
      Notifications.alert.confirm(
        "tarima",
        "¿Esta seguro de eliminar la tarima del contenedor",
        "Si Eliminar",
        function () {
          ContenedorService.remover_tarima_a_contenedor(self.current.id, {
            tarima_barra: current.barra,
          })
            .then((response) => {
              Notifications.alert.success("tarima", "Se ha eliminado la Información.");
              self.$emit("refresh", {});
            })
            .catch((error) => {
              Vue.nextTick(function () {
                if ("detail" in error.response.data) {
                  Notifications.alert.error("Error", error.response.data.detail);
                }
              });
            });
        }
      );
    },
  },
};
</script>
